import { DestroyRef, DOCUMENT, inject, Injectable, inject as ngInject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate } from '@angular/service-worker';
import { filter, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AppUpdateAvailableComponent } from './app-update-available/app-update-available.component';

@Injectable({
  providedIn: 'root',
})
export class AppUpdaterService {
  private document = inject<Document>(DOCUMENT);
  private swUpdateService = inject(SwUpdate);
  private destroyRef = ngInject(DestroyRef);
  private snackbar = inject(MatSnackBar);

  public init(): void {
    if (!this.swUpdateService.isEnabled) {
      return;
    }

    // Check for updates immediately on app start
    this.swUpdateService.checkForUpdate();

    // Listen for version updates
    this.swUpdateService.versionUpdates
      .pipe(
        filter(vu => vu.type === 'VERSION_READY'),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.snackbar
          .openFromComponent(AppUpdateAvailableComponent, {
            horizontalPosition: 'end',
            verticalPosition: 'top',
            politeness: 'assertive',
          })
          .onAction()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => {
            this.document.location.reload();
          });
      });

    // Check for updates every 5 minutes
    interval(5 * 60 * 1000)
      .pipe(
        switchMap(() => this.swUpdateService.checkForUpdate()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
